import { React } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';


// import square from "../../assets/icons/homepage/parthers/square.svg"
// import corner from "../../assets/icons/homepage/parthers/corner.svg"

// Returns null when the photo is not in the project yet, so the card shows a placeholder.
const getMemberImage = path => {
    try {
        return require('../../../assets/images/homepage/' + path);
    } catch (error) {
        return null;
    }
}

const getInitials = name => {
    const parts = name.trim().split(/\s+/);
    return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

const Member = props => {
    let img = props.img ? getMemberImage(props.img) : null;
    const alt = props.t("alt:homepage.team." + props.id);
    return (
        <Col sm={6} md={4} lg={3} className='member-card'>
            <div className='member-content'>
                <div className='member-img'>
                    {img
                        ? <Image src={img} alt={alt} />
                        : <div className='member-img-placeholder' role='img' aria-label={alt}>{getInitials(props.name)}</div>}
                </div>
                <div className='member-info'>
                    <h3>{props.name}</h3>
                    <p>{props.position}</p>
                </div>
                <div className='member-email'>
                    <Link className='email' to={"mailto:" + props.email}>{props.email}</Link>
                </div>
            </div>
        </Col>
    )
}

export default withTranslation()(Member);